import { render, staticRenderFns } from "./DeleteBulkConfirm.vue?vue&type=template&id=a573932c"
import script from "./DeleteBulkConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteBulkConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports